import '@nlux/themes/unstyled.css';
import './horatiotheme.css';

import React, { useState } from 'react';


const popupStyles = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(0,0,0,0.5)',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const modalStyles = {
  background: 'white',
  borderRadius: '12px',
  maxWidth: '90vw',
  maxHeight: '90vh',
  width: '500px',
  padding: '32px 24px 24px 24px',
  boxShadow: '0 4px 32px rgba(0,0,0,0.2)',
  position: 'relative',
  overflowY: 'auto',
};

const closeButtonStyles = {
  position: 'absolute',
  top: '16px',
  right: '16px',
  background: 'transparent',
  border: 'none',
  fontSize: '1.5rem',
  cursor: 'pointer',
  color: '#333',
};



const buttonStyles = {
  position: 'fixed',
  bottom: '24px',
  right: '24px',
  zIndex: 999,
  background: '#24233d',
  color: 'white',
  border: 'none',
  borderRadius: '24px',
  padding: '12px 24px',
  fontSize: '1rem',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
};
// Inline, small "More Info" button with up arrow
const inlineButtonStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.4em',
  color: '#24233d',
  backgroundColor: 'white',
  border: '2px solid #e5b316',
  borderRadius: '16px',
  padding: '2px 10px 2px 10px',
  fontSize: '0.92em',
  cursor: 'pointer',
  boxShadow: 'none',
  position: 'static',
  zIndex: 'auto',
  lineHeight: 1.2,
  verticalAlign: 'middle',
};

const headerStyles = {
  textAlign: 'center'
}

const textStyles = {
  textAlign: 'left'
};

const modalContentStyles = {
  overflowY: 'auto',
  maxHeight: '60vh', // or whatever value you prefer that fits in your modal
  paddingRight: '4px', // for scrollbar space, optional
};

// Inline "More Info" button for use inside text
export function MoreInfo() {
  const [show, setShow] = useState(false);

  // Handler for clicking on the overlay (outside modal)
  function handleOverlayClick(e) {
    if (e.target === e.currentTarget) {
      setShow(false);
    }
  }

  return (
    <>
      <button
        style={inlineButtonStyles}
        onClick={() => setShow(true)}
        aria-label="Learn More"
      >
        Learn More
        <span style={{ fontSize: '1em', marginLeft: '0.2em', lineHeight: 1 }}>↑</span>
      </button>

      {show && (
        <div style={popupStyles} onClick={handleOverlayClick}>
          <div style={modalStyles}>
            <button
              style={closeButtonStyles}
              onClick={() => setShow(false)}
              aria-label="Close"
            >
              ×
            </button>
            <div style={modalContentStyles}>
              <h3 style={headerStyles}>What is Horatio?</h3>
              <p style={textStyles}>Horatio is an AI assistant with access to the information contained in fund factsheets. If the information is in the factsheet, it should be in horatio.</p>
              <h3 style={headerStyles}>How much does horatio cost?</h3>
              <p style={textStyles}>
                horatio is free for reasonable use. If you hit our limits, or would like to use horatio in your own products or services, please reach out to <a href="mailto:hello@horatio.ai">hello@horatio.ai</a>
              </p>
              <h3 style={headerStyles}>Where does the data come from?</h3>
              <p style={textStyles}>The data is derived from public factsheets published by asset managers. The assistant should provide the sources in each response.</p>
              <h3 style={headerStyles}>Can I add additional funds or history?</h3>
              <p style={textStyles}>
                Yes. We are continually adding new funds to horatio. If horatio is missing some funds that you are interested in, please contact <a href="mailto:hello@horatio.ai">hello@horatio.ai</a>
              </p>
              <h3 style={headerStyles}>What about privacy?</h3>
              <p style={textStyles}>We use an OpenAI model, backed by content derived from publicly available information, sourced from the websites of Asset Managers. Our servers are hosted by Microsoft Azure (link to privacy). We do keep a copy of chats . . .</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
